"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var Rating_1 = __importDefault(require("@material-ui/lab/Rating"));
var React = __importStar(require("react"));
var icons_1 = require("../../../../common/icons");
var dateUtils_1 = require("../../../../youwell-common/dateUtils");
var translate_1 = __importDefault(require("../../../../app/localization/translate"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        root: {},
        dateCell: (_a = {
                flex: '0 0 100px'
            },
            _a[theme.breakpoints.down('xs')] = {
                flex: '0 0 68px',
            },
            _a),
        item: {
            display: 'flex',
            width: '100%',
            textAlign: 'left',
            justifyContent: 'flex-start',
            background: theme.palette.common.white,
            marginBottom: theme.spacing(1),
            padding: theme.spacing(0.5, 1),
        },
        itemContent: {
            flex: '1 1 auto',
        },
        activityText: {},
        activitySubText: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        loadMore: {
            marginTop: theme.spacing(4),
            display: 'flex',
            justifyContent: 'flex-end',
        },
    });
}, { name: 'ActivityList' });
var defaultShowCount = 10;
var ActivityList = function (_a) {
    var data = _a.data, onEditClick = _a.onEditClick, showRating = _a.showRating;
    var classes = useStyles();
    var translate = (0, translate_1.default)();
    var _b = React.useState(defaultShowCount), showCount = _b[0], setShowCount = _b[1];
    if (!data) {
        return null;
    }
    var editActivity = function (activity) { return function () {
        if (onEditClick) {
            onEditClick(activity);
        }
    }; };
    return (React.createElement("div", { className: classes.root }, data === null || data === void 0 ? void 0 :
        data.map(function (activity, i) { return (i < showCount ? (React.createElement(core_1.ButtonBase, { onClick: editActivity(activity), key: activity.id, className: classes.item },
            React.createElement(core_1.Typography, { variant: "caption", className: classes.dateCell }, (0, dateUtils_1.shortDate)(activity.date, translate)),
            React.createElement("div", { className: classes.itemContent },
                React.createElement(core_1.Typography, { variant: "subtitle2" }, activity.activity),
                React.createElement("div", { className: classes.activitySubText },
                    React.createElement(core_1.Typography, { variant: "body2", color: "textSecondary" }, (0, dateUtils_1.hourCount)(activity.durationInMinutes, translate)),
                    showRating && (React.createElement("div", null, activity.effortRating === -1 ? (React.createElement(core_1.Tooltip, { title: translate('activityDiary.notCompleted'), placement: "top" },
                        React.createElement(icons_1.NotInterestedIcon, { color: "disabled" }))) : (React.createElement(Rating_1.default, { size: "small", name: "effortRating-".concat(activity.id), value: activity.effortRating || 0, color: "primary", disabled: true })))))))) : null); }),
        data.length > showCount && (React.createElement("div", { className: classes.loadMore },
            React.createElement(core_1.Button, { size: "small", onClick: function () { return setShowCount(function (prev) { return prev + defaultShowCount; }); } }, translate('activityDiary.loadMore'))))));
};
ActivityList.defaultProps = {
    data: null,
    onEditClick: null,
    showRating: false,
};
exports.default = ActivityList;
